module.exports = __webpack_public_path__ + "static/media/googlemapex.78712d0c.png";